import React from "react";

const IronBear = () => {
  return (
    <div className="w-full h-screen fixed top-0 left-0">
      <div className="h-full  w-full relative">
        <video
          className="w-full h-full object-cover top-0  absolute"
          src="/logo-motions/iron-bear.mp4"
          autoPlay
          
          muted
          playsInline
        />
      </div>
    </div>
  );
};

export default IronBear;
